
import PreEntryApi from '../../assets/js/preentry'
import Uploader from './uploader'
import { i18nHelper } from '@it-common/lbp_common'
import OnboardHeader from '../OnboardHeader'
import $ from 'jquery'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
directives: {
TransferDom
},
components: {
XButton,
Flexbox,
FlexboxItem,
Loading,
Uploader,
Confirm,
XDialog,
OnboardHeader
},
data () {
return {
id: '',
isZH: localStorage.getItem('offer_zh') === 'zh',
quit_certify: [],
quit_certify_items: [],
physical_examination: [],
physical_examination_items: [],
showLoading: true,
delImageFlag: false,
hasShowPopup: { data: false },
delImageItem: { key: '', k: '', field: '' },
code: '',
show: false,
nowShowImg: '',
certify_status: 1,
medical_status: 1,
no_working: 1,
hidePhysical: true,
hiring_type: '',
work_type: '',
is_intern: ''
}
},
created () {
this.id = this.$route.query.id
this.$forceUpdate()


var localStorage = window.localStorage
this.code = localStorage.getItem('pre_code')
i18nHelper.loadLanguagePack(4159)
i18nHelper.setFixedLocale(localStorage.getItem('offer_zh'))
this.$forceUpdate()

if (!this.code || !this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}

PreEntryApi.checkLogin(
{ id: this.id, code: this.code },
data => {
if (data && data.isSubmit === true) {
this.$router.push({ name: 'onboard.preview', query: { id: this.id } })

}
},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
},
() => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
},
() => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
)

PreEntryApi.getStatusValue({ id: this.id, code: this.code }, data => {
if (data) {
this.medical_status = data.medical_status
this.certify_status = data.certify_status
this.no_working = data.no_working
}
})

PreEntryApi.getMaterial(
{ id: this.id, code: this.code },
data => {
if (data) {
this.quit_certify_items = data.quit_certify
this.physical_examination_items = data.physical_examination
data.quit_certify ? this.formatImageItems(data.quit_certify, 'quit_certify') : ''
data.physical_examination ? this.formatImageItems(data.physical_examination, 'physical_examination') : ''
}
this.showLoading = false
},
() => {
this.showLoading = false
},
() => {
this.showLoading = false
}
)

/**
* 1、获取预入职员工的类型【1：白领 2:蓝领 3:销售管理 4:店端】
* 2、获取预入职员工的部门id
* 3、如果是蓝领、并且是制造与质量-常州基地129、制造与质量-PACK厂103、制造与质量-质量管理部1703 的员工；学历附件非必填
*/
PreEntryApi.getStaffDetail({ id: this.id, code: this.code }, data => {
if (data) {
var jobType = data.job_type,
department2ID = data.department2_id
if (jobType === 2 && [129, 103, 1703].indexOf(department2ID) !== -1) {
this.hidePhysical = false
}
this.is_intern = data.is_intern
this.hiring_type = data.hiring_type

if (data.hiring_type === 2) {
PreEntryApi.getExperience(
{ id: this.id, getField: 'work_experience', code: this.code },
(data, meta) => {
if (data) {
data.forEach(item => {
if (item.work_type === 2) {
this.work_type = 2
}
})
}
this.showLoading = false
},
err => {
this.showLoading = false
}
)
}
}
})
},
mounted () {
$("input[type='file']").hide()
},
methods: {
showImg (src) {
this.nowShowImg = src
this.show = true
},
uploadCard (field) {
this.$refs[field].UploadFileType()
},
delImage (key, k, field) {
this.delImageItem.key = key
this.delImageItem.k = k
this.delImageItem.field = field
this.delImageFlag = true
},

sendDelImage () {
var field = this.delImageItem.field,
k = this.delImageItem.k,
key = this.delImageItem.key

this.delImageItem = { key: '', k: '', field: '' }
this[field + '_items'].splice(key * 2 + k, 1)
this[field + '_items'].splice(this[field + '_items'].length - 1, 1)

PreEntryApi.updateMaterialByField(
{
id: this.id,
code: this.code,
fieldName: field,
field: this[field + '_items']
},
() => {
this.formatImageItems(this[field + '_items'], field)
this.delImageFlag = false
}
)
},
returnFileData (res, field) {
var imgType = ['jpg', 'jpeg', 'png', 'gif']
if (imgType.indexOf(res.extension.toLowerCase()) === -1) {
if (res.extension.toLowerCase() === 'doc' || res.extension.toLowerCase() === 'docx') {
res.src = '/static/img/word.png'
} else {
res.src = '/static/img/pdf.png'
}
}
/*
var len = this[field].length;

if(len) {
if(this[field][len-1].length == 3) {
this[field].push([res]);
} else {
this[field][len-1].push(res);
}
} else {
this[field].push([res]);
}
*/
if (this[field + '_items'].length > 0 && !this[field + '_items'][this[field + '_items'].length - 1]['id']) {
this[field + '_items'].splice(this[field + '_items'].length - 1, 1)
}

this[field + '_items'].push(res)
this.formatImageItems(this[field + '_items'], field)
},
formatImageItems (fields, fieldName) {
var src = '/static/img/y-8.png'
if (fieldName === 'quit_certify') {
src = '/static/img/y-8.png'
}
if (fieldName === 'physical_examination') {
src = '/static/img/y-9.png'
}
if (!this.isZh) {
src = '/static/img/y-en.png'
}

fields.push({
id: '',
src: src,
url: '',
extension: 'png'
})

if (fieldName === 'quit_certify' && fields.length === 0) {
fields.push({
id: '',
src: src,
url: '',
extension: 'png'
})
}
if (fields) {
this[fieldName] = []

var tempArray = []
fields.forEach(
function (item, index) {
var imgType = ['jpg', 'jpeg', 'png', 'gif']
var src = item.src
if (imgType.indexOf(item.extension.toLowerCase()) === -1) {
if (item.extension.toLowerCase() === 'doc' || item.extension.toLowerCase() === 'docx') {
src = '/static/img/word.png'
} else {
src = '/static/img/pdf.png'
}
}

tempArray.push({
id: item.id,
src: src,
url: item.url
})
if ((index + 1) % 2 === 0 && index !== 0) {
this[fieldName].push(tempArray)
tempArray = []
}
}.bind(this)
)
if (tempArray.length) {
this[fieldName].push(tempArray)
tempArray = []
}
}
},

getIsZh (data) {
var localStorage = window.localStorage
if (data) {
localStorage.setItem('offer_zh', 'zh')

} else {
localStorage.setItem('offer_zh', 'en')

}
this.isZH = data
},
showStep () {
this.hasShowPopup.data = !this.hasShowPopup.data
},
sendMaterial (flag) {
PreEntryApi.changeCertifyStatus({ id: this.id, code: this.code }).then(data => {
if (flag === 2) {
this.$router.push({ name: 'onboard.certificate', query: { id: this.id } })
return false
} else {
this.$router.push({ name: 'onboard.list', query: { id: this.id } })
return false
}
})
},
handleAvatarSuccess (res) {
if (res.code !== 0) {
this.$message.error(this.$tsg('上传失败。'))
return false
}

if (res.field === 'physical_examination') {
this.fileList = [
{
name: res.data.name
}
]
}

this[res.field + '_url'] = res.data.pre_url
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/certify.vue